import React from 'react'
import { useNavigate } from 'react-router-dom'
import GokuDataGrid from '@/components/GokuDataGrid'
import SubHeaders from '@/components/Headers/SubHeaders'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { useConfirmation } from '@/contexts/confirmation'
import type { IPermissionProps } from '@/types/shared'
import { getRoles, deleteRole } from '../../services'
import type { Role } from '../../types'
import { RoleColumns } from './columns'
import EditIcons from '@/icons/EditIcons'
import DeleteOutlineIcons from '@/icons/DeleteOutlineIcons'
import AddIcons from '@/icons/AddIcons'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const List: React.FC<IPermissionProps> = () => {
    const navigate = useNavigate()
    const { setConfirmation } = useConfirmation()

    const rolesRefetch = useDataGridRefetch({
        reactQueryKey: 'roles',
    })

    const { mutateAsync: doDeleteRole, isPending: inDeleteProcessing } =
        useMutationWithHandler(
            {
                mutationFn: deleteRole,
            },
            {
                reactQueryKeys: QUERY_KEYS.ROLES,
                successMessage: 'Xóa vai trò thành công',
                errorMessage: 'Có lỗi xảy ra khi xóa vai trò',
                onSuccess: () => {
                    rolesRefetch.refetchCurrent()
                },
            }
        )

    const handleDeleteRole = (role: Role) => {
        setConfirmation({
            open: true,
            title: 'Xóa vai trò',
            description: `Bạn có chắc chắn muốn xóa vai trò "${role?.name}"?`,
            onConfirm: () => doDeleteRole(role.name),
        })
    }

    return (
        <>
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: 'Thêm vai trò',
                        onClick: () => navigate('/roles/new'),
                        variant: 'contained',
                    },
                ]}
                breadcrumbs={[
                    {
                        path: '/',
                        title: 'Trang chủ',
                    },
                    {
                        path: '/roles',
                        title: 'Quản lý vai trò',
                    },
                ]}
            />

            <GokuDataGrid
                apiCall={getRoles}
                columns={RoleColumns}
                reactQueryKey="roles"
                dataGridProps={{
                    getRowId: (row) => row?.id,
                    hideFooter: true,
                }}
                actions={[
                    {
                        onClick: (row: Role) => navigate(`/roles/${row?.name}`),
                        title: 'Chỉnh sửa',
                        icon: <EditIcons />,
                        color: 'info',
                    },
                    {
                        onClick: handleDeleteRole,
                        title: 'Xóa',
                        icon: <DeleteOutlineIcons />,
                        disabled: () => inDeleteProcessing,
                        color: 'error',
                    },
                ]}
            />
        </>
    )
}

export default List
